import { devConfig } from '../../dev/dev.config';
import type { StandsKeys } from './Stands';
export const appVersionsFileName = 'appVersions.json';
const webStaticApiIsLocal = devConfig.useBackendLocal.includes('webStaticApi');
export const MicroFrontendsHosts: Record<StandsKeys, string> = {
	test: 'https://mfs.efrtest.ru',
	cert: 'https://mfs.efrcert.ru',
	prod: 'https://mfs.efr.ru',
};

export const WebStaticHosts: Record<StandsKeys, string> = webStaticApiIsLocal
	? {
			test: 'http://localhost:3200',
			cert: 'http://localhost:3200',
			prod: 'http://localhost:3200',
		}
	: {
			test: 'https://web-static-api.efrtest.ru',
			cert: 'https://web-static-api.efrcert.ru',
			prod: 'https://web-static-api.efr.ru',
		};

export const LocalizationHosts: Record<StandsKeys, string> = {
	test: `${WebStaticHosts.test}/dictionary/web`,
	cert: `${WebStaticHosts.cert}/dictionary/web`,
	prod: `${WebStaticHosts.prod}/dictionary/web`,
};
export const appVersionsHost: Record<StandsKeys, string> = {
	test: `${MicroFrontendsHosts.test}/${appVersionsFileName}`,
	cert: `${MicroFrontendsHosts.cert}/${appVersionsFileName}`,
	prod: `${MicroFrontendsHosts.prod}/${appVersionsFileName}`,
};

export const appReviewHost: Record<StandsKeys, string> = {
	test: 'https://review.efrtest.ru',
	cert: 'https://review.efrcert.ru',
	prod: 'https://review.efrcert.ru',
};
export const CompanyDomains: Record<StandsKeys, string[]> = {
	test: ['techefr.ru', 'auth-af.efr.ru', 'efrtest.ru', 'efintest.ru'],
	cert: ['techefr.ru', 'auth-af.efr.ru', 'efrcert.ru', 'efincert.ru'],
	prod: ['techefr.ru', 'efr.ru', 'efin.ru'],
};
export const PartnerDomains = ['drom.ru'];
export const OtherDomains = [
	'yandexcloud.net',
	'yandex.ru',
	'dadata.ru',
	'scoring.ru',
	'juicyscore.ru',
	'juicyscore.net',
	'juicyscore.com',
];
export const OtherWebStaticDomains = ['mc.yandex.ru'];
